import { render, staticRenderFns } from "./Gmail.vue?vue&type=template&id=9c10ee7e"
import script from "./Gmail.vue?vue&type=script&lang=js"
export * from "./Gmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports